import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import './Projects.css';

const Projects = () => {
  const { tr } = useLanguage();
  const p = tr.projects;

  return (
    <section id="projetos" className="projects">
      <div className="projects-header">
        <p className="section-title">{p.title}</p>
        <h2 className="projects-subtitle">{p.subtitle}</h2>
        <p className="projects-desc">{p.description}</p>
      </div>
      <div className="projects-grid">
        {p.items.map((proj, i) => (
          <div key={i} className="proj-card">
            <div className="proj-card-top">
              <span className="proj-badge">{p.badge}</span>
              <h3 className="proj-title">{proj.title}</h3>
              <p className="proj-subtitle">{proj.subtitle}</p>
            </div>
            <p className="proj-description">{proj.description}</p>
            <div className="proj-section">
              <span className="proj-label">{p.stackLabel}</span>
              <div className="proj-chips">
                {proj.stack.map(s => (
                  <span key={s} className="proj-chip">{s}</span>
                ))}
              </div>
            </div>
            <div className="proj-section">
              <span className="proj-label">{p.focusLabel}</span>
              <p className="proj-focus">{proj.focus}</p>
            </div>
            <div className="proj-section">
              <span className="proj-label">{p.decisionsLabel}</span>
              <ul className="proj-decisions">
                {proj.decisions.map((d, j) => (
                  <li key={j}>{d}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Projects;
